export default __webpack_public_path__ + "static/media/story-2.30f3c969.png";